import { TransformRT2 } from '@seddi/math-v2';
/**
 * Computes the initial transform from a region.
 *
 * By default the logo is centered using the region transform.
 * For Chest and Back regions, the logo is top-aligned vertically, mirroring
 * the "top" alignment logic from DesignLogoAligmentButtons (for a non-rotated logo).
 */
export const getInitialTransformFromRegion = (region, logoSize, is2DProduct) => {
    const regionTransform = region.transform;
    // Default transform is the region's transform (centered in the region)
    let transform = regionTransform;
    // For Chest and Back regions, place the logo top-aligned by default.
    if (region.name === 'Chest' || region.name === 'Back') {
        // In import, logo rotation matches region rotation, so relativeRotation = 0
        // and the effective height equals logoSize.y.
        const rotatedHeight = logoSize.y;
        // Translation in the region's local coordinate system
        const localTranslation = { x: 0, y: 0 };
        // For 2D styles, the Y-axis is inverted – mirror the logic from
        // DesignLogoAligmentButtons "top" case.
        localTranslation.y = is2DProduct
            ? (rotatedHeight - region.size.y) / 2
            : (region.size.y - rotatedHeight) / 2;
        const mTransform = TransformRT2.Matrix(regionTransform);
        mTransform.transformRef(localTranslation);
        transform = Object.assign(Object.assign({}, regionTransform), { translation: localTranslation });
    }
    return transform;
};
